// Reseller Service - GraphQL operations for Reseller role
import { graphqlClient } from '../graphqlClient';

// ==================== Profile ====================

export const getProfile = async () => {
  const query = `
    query GetResellerProfile {
      resellerProfile {
        id
        email
        name
        status
        code
        depositCommission
        withdrawalCommission
        percentageFee
        parentName
        parentType
        parentDepositCommission
        parentWithdrawalCommission
        parentPercentageFee
        createdAt
        updatedAt
      }
    }
  `;
  
  const result = await graphqlClient.query(query);
  return result.resellerProfile;
};

// ==================== Merchant Operations ====================

export const getMyMerchants = async () => {
  const query = `
    query GetResellerMerchants {
      resellerMerchants {
        id
        code
        email
        name
        status
        createdByAdminId
        createdByEngineId
        createdByResellerId
        createdAt
        updatedAt
      }
    }
  `;
  
  const result = await graphqlClient.query(query);
  return result.resellerMerchants;
};

export const getMerchantById = async (id) => {
  const query = `
    query GetResellerMerchantById($id: String!) {
      resellerMerchantById(id: $id) {
        id
        code
        email
        name
        status
        depositCommission
        withdrawalCommission
        percentageFee
        createdAt
        updatedAt
      }
    }
  `;
  
  const result = await graphqlClient.query(query, { id });
  return result.resellerMerchantById;
};

export const createMerchant = async (input) => {
  const mutation = `
    mutation ResellerCreateMerchant($input: ResellerCreateMerchantInput!) {
      resellerCreateMerchant(input: $input) {
        id
        code
        email
        name
        status
        createdAt
        updatedAt
      }
    }
  `;
  
  const result = await graphqlClient.mutate(mutation, { input });
  return result.resellerCreateMerchant;
};

export const updateMerchant = async (id, input) => {
  const mutation = `
    mutation ResellerUpdateMerchant($id: String!, $input: ResellerUpdateMerchantInput!) {
      resellerUpdateMerchant(id: $id, input: $input) {
        id
        code
        email
        name
        status
        createdAt
        updatedAt
      }
    }
  `;
  
  const result = await graphqlClient.mutate(mutation, { id, input });
  return result.resellerUpdateMerchant;
};

export const deleteMerchant = async (id) => {
  const mutation = `
    mutation ResellerDeleteMerchant($id: String!) {
      resellerDeleteMerchant(id: $id)
    }
  `;
  
  const result = await graphqlClient.mutate(mutation, { id });
  return result.resellerDeleteMerchant;
};

// ==================== Dashboard Stats ====================

export const getDashboardStats = async () => {
  const query = `
    query GetResellerDashboardStats {
      resellerDashboardStats {
        totalMerchants
        activeMerchants
      }
    }
  `;
  
  const result = await graphqlClient.query(query);
  return result.resellerDashboardStats;
};

